module.exports = __webpack_public_path__ + "static/media/last_getty_desktop.a2965119.jpg";